import { render, staticRenderFns } from "./StepUpload.vue?vue&type=template&id=6b2e99f9&scoped=true&"
import script from "./StepUpload.vue?vue&type=script&lang=js&"
export * from "./StepUpload.vue?vue&type=script&lang=js&"
import style0 from "./StepUpload.vue?vue&type=style&index=0&id=6b2e99f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e99f9",
  null
  
)

export default component.exports